import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b513a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "buttons larger-action-button mt-6" }

import { ref, onMounted } from 'vue'

import Modal from '@/popup/components/shared/Modal/Modal'
import Button from '@/popup/components/shared/Button.vue'
import { Error, Input } from '@/popup/components/shared/Form/Form'
import { InputError } from '@/popup/components/shared/Form/FormTypes'
import { t } from '@/popup/lib/i18n'

type Emits = {
  (event: 'on-cancel'): void
  (event: 'on-submit', newName: string): void
}

type Props = {
  controllerName: string | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RenameController',
  props: {
    controllerName: {}
  },
  emits: ["on-cancel", "on-submit"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const name = ref('')
const errors = ref<InputError[]>([])
const focus = ref(false)

const onCancel = () => {
  emits('on-cancel')
}

const onSubmit = () => {
  if (!name.value) {
    errors.value = [t('input.validators.required')]
    return
  }
  emits('on-submit', name.value)
}

onMounted(async () => {
  name.value = props.controllerName ?? ''
  focus.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, { "extra-class": "wider" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, {
        "extra-class": "darker blurry",
        onClick: onCancel
      }),
      _createVNode(_unref(Modal).Content, { "extra-class": "wider higher" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal).Heading, { "extra-class": "larger" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('app.controller_permissions.rename_controller')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("form", {
              class: "password-form",
              onSubmit: _withModifiers(onSubmit, ["prevent"])
            }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('app.controller_permissions.rename_controller_info')), 1 /* TEXT */),
              _createVNode(_unref(Input), {
                name: "name",
                value: name.value,
                "show-info": false,
                autofocus: focus.value,
                "is-bordered": true,
                errors: errors.value,
                size: "large",
                "extra-classes": "input text-input",
                "data-testid": "name",
                onOnUpdate: _cache[0] || (_cache[0] = value => (name.value = value)),
                onOnErrors: _cache[1] || (_cache[1] = errs => (errors.value = errs))
              }, null, 8 /* PROPS */, ["value", "autofocus", "errors"]),
              (errors.value?.length)
                ? (_openBlock(), _createBlock(_unref(Error), {
                    key: 0,
                    error: errors.value[0]
                  }, null, 8 /* PROPS */, ["error"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(Button, {
                  variant: "text",
                  type: "button",
                  onClick: onCancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('qr_code.import_profile.cancel')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(Button, {
                  class: "submit",
                  disabled: !name.value,
                  "is-full-width": true,
                  "data-testid": "modal-backup-button",
                  type: "submit",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('app.controller_permissions.rename_controller')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})